import { makeAutoObservable } from 'mobx';
class AdministratorStore {
  company: string[];

  constructor(company = []) {
    this.company = company;
    makeAutoObservable(this);
  }

  getCompanyInfo() {
    return `Administrator of company: ${this.company.join(', ')}`;
  }
}

export const administratorStore = new AdministratorStore();
